import React from 'react';
import { BounceLoader } from 'react-spinners';
import { GreyColor } from '../configs/globals';

export const Loader = ({ loading = false, color = GreyColor, ...props }) => (
	<div className="container loader loader__container loader__container--column loader--center" {...props}>
		<BounceLoader loading={loading} color={color} />
		<span className="text row row--top-30">Wczytywanie danych...</span>
	</div>
);
